import { PartnerPlatform } from '../PartnerPlatform/PartnerPlatform';

export interface SynchronizationSummary {
  internalProductCount: number;
  platformCounts: Record<PartnerPlatform, number>;
  lastUpdated: Date;
}

export const synchronizationSummaryFromResponse = (
  responseData: any,
): SynchronizationSummary => ({
  internalProductCount: responseData.internal_product_count,
  platformCounts: {
    trendyol: responseData.trendyol_product_count,
    hepsiburada: responseData.hepsiburada_product_count,
    boyner: responseData.boyner_product_count,
    n11: responseData.n11_product_count,
    pazarama: responseData.pazarama_product_count,
    internal: responseData.internal_product_count,
  },
  lastUpdated: new Date(responseData.last_updated),
});
